module.exports = __webpack_public_path__ + "img/7.bee8d72e.jpg";